import classNames from 'classnames';

interface Props {
    caption?: string;
    currentImage: number;
    numberOfImages: number;
    small?: boolean;
    showOnHover?: boolean;
}

export const ImageCarouselCaption = ({ caption, currentImage, numberOfImages, small = false, showOnHover }: Props) => (
    <p className="image-carousel__caption">
        <span
            className={classNames('image-carousel__caption-text image-carousel_a11y-text u-truncate', {
                'image-carousel__caption-text-small': small,
                'image-carousel__element-show-on-hover': showOnHover,
            })}>
            {caption ? `${caption} ` : ''}({currentImage}/{numberOfImages})
        </span>
    </p>
);
